module.exports = __webpack_public_path__ + "logo-neumomed.png?e90ffcb41c14367ad23eb9f329042d98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-neumomed.png
// module id = 735
// module chunks = 0